(() => {
  const selector = "shipping-estimator button[type=\"button\"]";

  const messageForRates = (rates) => {
    const strings = window.themeVariables.strings;

    if (rates.length === 0) {
      return strings.shippingEstimatorNoResults;
    }

    if (rates.length === 1) {
      return strings.shippingEstimatorOneResult;
    }

    return strings.shippingEstimatorMultipleResults;
  };

  const formatRate = (rate) => {
    const locale = document.documentElement.lang || "en-US";
    const currency = rate.currency || "USD";

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency
    }).format(Number(rate.price));
  };

  const removeResults = (estimator) => {
    estimator.querySelector(".shipping-estimator__results")?.remove();
  };

  const showRates = (estimator, rates) => {
    removeResults(estimator);

    const results = document.createElement("div");
    results.className = "shipping-estimator__results";

    const message = document.createElement("p");
    message.textContent = messageForRates(rates);
    results.append(message);

    if (rates.length > 0) {
      const list = document.createElement("ul");
      list.className = "unordered-list";

      rates.forEach((rate) => {
        const item = document.createElement("li");
        item.textContent = `${rate.presentment_name || rate.name}: ${formatRate(rate)}`;
        list.append(item);
      });

      results.append(list);
    }

    estimator.append(results);
  };

  const showError = (estimator, payload) => {
    removeResults(estimator);

    const results = document.createElement("div");
    results.className = "shipping-estimator__results";

    const message = document.createElement("p");
    message.textContent = window.themeVariables.strings.shippingEstimatorError;
    results.append(message);

    const errors = payload?.errors || payload;

    if (errors && typeof errors === "object") {
      const list = document.createElement("ul");
      list.className = "unordered-list";

      Object.entries(errors).forEach(([field, detail]) => {
        const item = document.createElement("li");
        item.textContent = `${field} ${Array.isArray(detail) ? detail.join(", ") : detail}`;
        list.append(item);
      });

      results.append(list);
    }

    estimator.append(results);
  };

  const estimate = async (event, button) => {
    const estimator = button.closest("shipping-estimator");

    if (!estimator || button.hasAttribute("aria-busy")) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    button.setAttribute("aria-busy", "true");

    const params = new URLSearchParams();
    params.set("shipping_address[zip]", estimator.querySelector('[name="shipping-estimator[zip]"]').value.trim());
    params.set("shipping_address[country]", estimator.querySelector('[name="shipping-estimator[country]"]').value);
    params.set("shipping_address[province]", estimator.querySelector('[name="shipping-estimator[province]"]')?.value || "");

    try {
      const response = await fetch(`${window.themeVariables.routes.cartUrl}/shipping_rates.json?${params.toString()}`, {
        headers: {
          Accept: "application/json"
        }
      });
      const payload = await response.json();

      if (!response.ok) {
        throw payload;
      }

      showRates(estimator, payload.shipping_rates || []);
    } catch (error) {
      showError(estimator, error);
    } finally {
      button.removeAttribute("aria-busy");
    }
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest(selector);

    if (button) {
      estimate(event, button);
    }
  }, true);
})();
